module.exports = __webpack_public_path__ + "img/text2.24fd036e.png";